export default "__VITE_ASSET__d1568ddf__"